import React, { memo } from "react";

import { Badge, BadgeText } from "@/components/atoms/Badge";

/**
 *
 */
interface LimitedDataWarningBadgeViewProps {
  isSmallScreen: boolean;
}

/**
 * Presentational component that renders a warning badge indicating limited data availability.
 * @param root0 - Component props
 * @param root0.isSmallScreen - Whether the screen size is small (affects whether bold font is applied)
 */
const LimitedDataWarningBadgeView = ({
  isSmallScreen,
}: LimitedDataWarningBadgeViewProps) => (
  <Badge size="lg" variant="solid" action="warning">
    <BadgeText {...(!isSmallScreen ? { className: "font-heading" } : {})}>
      Limited Data
    </BadgeText>
  </Badge>
);

LimitedDataWarningBadgeView.displayName = "LimitedDataWarningBadgeView";

export default memo(LimitedDataWarningBadgeView);
